import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

class ReviewResponsesPage extends Component {

  state = {
    profileId: false,
  }

  componentWillMount(){

    const profileId = this.props.isViewingUser ? this.props.match.params.employeeId : this.props.user._id;
    
    this.setState({
      profileId,
    });
  }

  render(){
    return (
      <Page pageClass="responses">
        <div className="page-title">
          <h1>Review {this.props.isViewingUser ? 'Your' : 'Employee'} Responses</h1>
          <h3>Subheader</h3>
        </div>
        <div className="page-actions">
          <button className="button primary">Primary</button>
          <button className="button grey-button">Secondary</button>
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(ReviewResponsesPage);



// WEBPACK FOOTER //
// ./src/components/responses/index.js